module.exports = __webpack_public_path__ + "img/search-blue.5aef3330.svg";